import { useCustomTestCreateWizard } from 'pages/custom_tests_v1/components/custom_test_create_wizard/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { Table } from 'react-bootstrap';

export const ConfirmStep = () => {

    const { name, categories, categoryId, minScore, minutes, modeId, productIds, products, randomly, selectedQuestions, useRandomly } = useCustomTestCreateWizard();
    const { formatMessage } = useIntl();

    const selectedCategory = categories.find(({ Id }) => Id === categoryId);
    const selectedProducts = products.filter(({ Id }) => productIds.includes(Id));

    const modeLabel = modeId === 1
        ? (formatMessage({ id: 'training_mode.26ca842d', defaultMessage: 'Training Mode' }))
        : (formatMessage({ id: 'testing_mode.3727f585', defaultMessage: 'Testing Mode' }));

    const productsCell = selectedProducts.map(entry => entry.Name);
    const minScoreCell = `${minScore}%`;
    const timeLimitCell = `${minutes} ${formatMessage({ id: 'minutes.63f04957', defaultMessage: 'minutes' })}`;
    const questionsCell = `${selectedQuestions} ${formatMessage({ id: 'questions_selected.11c36841', defaultMessage: 'questions selected' })}`;
    const randomizeCell = `${formatMessage({ id: 'yes.104886cd', defaultMessage: 'Yes', description: 'Formulario' })} — ${randomly} ${formatMessage({ id: 'number_of_random_questions_to_show.cdd6ff9a', defaultMessage: 'Number of random questions to show' })}`;

    return (
        <div className="py-3">
            <h5 className="mb-3">
                {<FormattedMessage defaultMessage="Confirm Settings" id="confirm_settings.cda2fcd8" />}
            </h5>
            <p className="text-muted mb-4">
                {<FormattedMessage defaultMessage="Review your custom test settings before creating." id="review_your_custom_test_settings_before.ba22af14" />}
            </p>

            <Table bordered className="mb-0" size="sm">
                <tbody>
                    <tr>
                        <th className="w-25 p-3 align-middle">
                            {<FormattedMessage defaultMessage="Test Name" id="test_name.77ea159f" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {name}
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Category" id="category.f324da36" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {selectedCategory?.Name}
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Products" id="products.b940f0f9" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            <div className={'d-flex flex-column gap-1'}>
                                {!!productsCell?.length && productsCell.map((product, key) => (
                                    <span key={key}>
                                        {product}
                                    </span>
                                ))}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Minimum Score (%)" id="minimum_score_percent.9c3d3125" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {minScoreCell}
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Time Limit (minutes)" id="time_limit_minutes.cd2ccbb5" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {timeLimitCell}
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Mode" description={formatMessage({ id: 'formulario.6dc35e9d', defaultMessage: 'Formulario' })} id="mode.f65b1f2b" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {modeLabel}
                        </td>
                    </tr>
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Questions" id="questions.940c8cce" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {questionsCell}
                        </td>
                    </tr>
                    {useRandomly && (
                    <tr>
                        <th className={'p-3 align-middle'}>
                            {<FormattedMessage defaultMessage="Randomize Questions" id="randomize_questions.26374601" />}
                        </th>
                        <td className={'p-3 align-middle'}>
                            {randomizeCell}
                        </td>
                    </tr>
                    )}
                </tbody>
            </Table>
        </div>

    );

};
